// Regras da resposta à exigência pelo requerente (change requerente-responde-exigencia).
// A recusa de verdade é da API (tramitacao_rules.check_resposta); aqui só se decide o que oferecer na tela.

const DEFAULT_PRAZO_DIAS = 15;
const MIN_ANSWER_LENGTH = 3;
const DAY_MS = 24 * 60 * 60 * 1000;

export function isExigencia(move) {
  return Boolean(move?.is_exigencia || move?.exigencia);
}

export function isOpenExigencia(move) {
  if (!isExigencia(move)) return false;
  return !move.exigencia_status || move.exigencia_status === 'aberta';
}

/** Mesma conta de process-service `prazo_final`: data de entrada + prazo (padrão 15 dias). */
export function exigenciaDeadline(move) {
  if (!move?.data_entrada) return null;
  const raw = String(move.data_entrada);
  // Data sem fuso vem do backend em UTC.
  const hasZone = /([zZ]|[+-]\d{2}:?\d{2})$/.test(raw);
  const start = new Date(hasZone || !raw.includes('T') ? raw : `${raw}Z`);
  if (Number.isNaN(start.getTime())) return null;
  const days = Number(move.prazo_dias) || DEFAULT_PRAZO_DIAS;
  return new Date(start.getTime() + days * DAY_MS);
}

export function isExigenciaExpired(move, now = new Date()) {
  const deadline = exigenciaDeadline(move);
  return Boolean(deadline && now > deadline);
}

export function canAnswerExigencia(move, now = new Date()) {
  return isOpenExigencia(move) && !isExigenciaExpired(move, now);
}

export function hasOpenExigencia(moves) {
  return (moves || []).some(isOpenExigencia);
}

/** Tipo de mídia do anexo da resposta: "Documento" (padrão do órgão) ou o primeiro cadastrado. */
export function pickAnswerMediaTypeId(midias) {
  const list = midias || [];
  const documento = list.find((m) => String(m?.tipo || '').trim().toLowerCase() === 'documento');
  return (documento || list[0])?.id || '';
}

/**
 * Envia a resposta. Com arquivo, grava o arquivo no processo antes; se o upload falhar,
 * a exceção sobe e a resposta não é enviada.
 */
export async function submitExigenciaAnswer({ move, processoId, tipoId, texto, file }, service) {
  const body = String(texto || '').trim();
  if (body.length < MIN_ANSWER_LENGTH) {
    throw new Error('Escreva a resposta da exigência.');
  }
  let finalText = body;
  if (file) {
    if (!tipoId) {
      throw new Error('O órgão não tem tipo de mídia cadastrado. Envie o arquivo por Protocolar petição.');
    }
    await service.uploadDocumentoProcesso(processoId, tipoId, file);
    finalText = `${body}\n\nArquivo anexado: ${file.name}`;
  }
  return service.responderExigencia(move.id, { texto: finalText });
}
